import { ArrowRight } from 'lucide-react'
import { Link, type LinkProps } from './Link'

export function CommercialLink({ children, className, ...props }: LinkProps) {
  return (
    <Link variant="primary" className={`commercial-cta__action${className ? ` ${className}` : ''}`} {...props}>
      <span>{children}</span>
      <ArrowRight className="commercial-cta__icon" aria-hidden="true" />
    </Link>
  )
}
